import AllSpecifications from './AllSpecifications';
export default AllSpecifications;
